import Config from '@/shared/Config'

const TAB_UUID_KEY = 'ai_agent_tab_uuid'

function getTabUUID () {
  let uuid = sessionStorage.getItem(TAB_UUID_KEY)
  if (!uuid) {
    uuid = crypto.randomUUID()
    sessionStorage.setItem(TAB_UUID_KEY, uuid)
  }
  return uuid
}

/**
 * Build the composite session ID: project_id:user_id:tab_uuid
 *
 * This format matches the gateway's scope validation:
 * the gateway extracts project_id:user_id from the token and
 * verifies it matches the session_id prefix.
 *
 * Falls back to just the tab UUID if context is not yet available
 * (the WS auth will fail and retry once mounted).
 */
export async function getSessionId () {
  const tabUUID = getTabUUID()

  try {
    const config = await Config()
    const projectId = config?.PROJECT_ID || ''

    const store = window.__fpui_store__
    const session = store?.getters?.SESSION || store?.getters?.KING_SESSION
    const userId = session?.sub || session?._id || ''

    if (projectId && userId) {
      return `${projectId}:${userId}:${tabUUID}`
    }
  } catch { /* context not ready yet */ }

  return tabUUID
}

/**
 * Synchronous version — returns cached value or tab UUID only.
 * Use getSessionId() (async) when possible.
 */
export function getSessionIdSync () {
  return getTabUUID()
}
